/**
 * The web nav bar's side padding. The web `Header` uses the same value so Back sits under the
 * logo and the header's right items under the account menu; change both by changing this.
 */
export const NAV_BAR_GUTTER_CLASS = 'px-4 lg:px-8';
